import API from 'api/hallomart';
import Auth from 'api/auth';
import { INITIALIZING, INITIALIZED, init } from 'modules/app';
import { push } from 'react-router-redux';

/**
 * Constants
 */

export const LOGINING = 'auth/LOGINING';
export const LOGINED_IN_SUCCESS = 'auth/LOGINED_IN_SUCCESS';
export const LOGIN_USER = 'auth/LOGIN_USER';
export const UNEXPECTED_ERROR = 'auth/UNEXPECTED_ERROR';
export const LOGOUT = 'auth/LOGOUT';
export const CHECK_TOKEN = 'auth/CHECK_TOKEN';
export const CHECK_TOKEN_OK = 'auth/CHECK_TOKEN_OK';
export const CHECK_TOKEN_ERROR = 'auth/CHECK_TOKEN_ERROR';

/**
 * Action Creators
 */

export function loginUser(username, password) {
  return async (dispatch) => {
    try {
      dispatch({ type: LOGINING });

      const res = await API.login(username, password);
      const authToken = res.data.token;

      localStorage.setItem('token', authToken);
      dispatch({ type: LOGIN_USER, token: authToken });

      dispatch(push('/profile'));
      dispatch({ type: LOGINED_IN_SUCCESS });
    } catch (err) {
      dispatch({ type: UNEXPECTED_ERROR, error: err.response || err.message });
    }
  };
}

export function logout() {
  return (dispatch) => {
    localStorage.removeItem('token');
    dispatch({ type: LOGOUT });
    dispatch(init());
    dispatch(push('/login'));
  };
}

export function checkToken() {
  return async (dispatch) => {
    try {
      dispatch({ type: CHECK_TOKEN });

      await Auth.checkToken();
      dispatch({ type: CHECK_TOKEN_OK });
    } catch (err) {
      dispatch({ type: CHECK_TOKEN_ERROR, error: err.response || err.message });

      // Delete the token from local storage
      localStorage.removeItem('token');
    }
  };
}

/**
 * Reducers
 */

const initialState = {
  logining: false,
  loginedIn: false,
  token: '',
  error: false,
  errors: {},
  isExpired: false,
};

export default function auth(state = initialState, action) {
  switch (action.type) {
    case INITIALIZING: {
      if (action.token) {
        return {
          ...state,
          loginedIn: true,
          token: action.token,
        };
      }
      return state;
    }

    case INITIALIZED: {
      if (action.token) {
        return {
          ...state,
          loginedIn: true,
          token: action.token,
          error: false,
        };
      }
      return state;
    }

    case CHECK_TOKEN:
    case LOGINING:
      return {
        ...state,
        logining: true,
        error: false,
        errors: {},
        isExpired: false,
      };

    case CHECK_TOKEN_OK:
    case LOGINED_IN_SUCCESS:
      return {
        ...state,
        logining: false,
      };

    case LOGIN_USER:
      return {
        ...state,
        loginedIn: true,
        token: action.token,
      };

    case UNEXPECTED_ERROR:
      return {
        ...state,
        error: true,
        logining: false,
        errors: action.error,
      };

    case CHECK_TOKEN_ERROR:
      return {
        ...state,
        logining: false,
        loginedIn: false,
        error: true,
        token: '',
        isExpired: action.error.data.message === 'Expired token',
      };

    case LOGOUT:
      return initialState;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/auth.js